[
    {
      "sigla": "AG",
      "denominazione": "Agrigento"
    },
    {
      "sigla": "AL",
      "denominazione": "Alessandria"
    },
    {
      "sigla": "AN",
      "denominazione": "Ancona"
    },
    {
      "sigla": "AO",
      "denominazione": "Valle d'Aosta/Vallée d'Aoste"
    },
    {
      "sigla": "AP",
      "denominazione": "Ascoli Piceno"
    },
    {
      "sigla": "AQ",
      "denominazione": "L'Aquila"
    },
    {
      "sigla": "AR",
      "denominazione": "Arezzo"
    },
    {
      "sigla": "AT",
      "denominazione": "Asti"
    },
    {
      "sigla": "AV",
      "denominazione": "Avellino"
    },
    {
      "sigla": "BA",
      "denominazione": "Bari"
    },
    {
      "sigla": "BG",
      "denominazione": "Bergamo"
    },
    {
      "sigla": "BI",
      "denominazione": "Biella"
    },
    {
      "sigla": "BL",
      "denominazione": "Belluno"
    },
    {
      "sigla": "BN",
      "denominazione": "Benevento"
    },
    {
      "sigla": "BO",
      "denominazione": "Bologna"
    },
    {
      "sigla": "BR",
      "denominazione": "Brindisi"
    },
    {
      "sigla": "BS",
      "denominazione": "Brescia"
    },
    {
      "sigla": "BT",
      "denominazione": "Barletta-Andria-Trani"
    },
    {
      "sigla": "BZ",
      "denominazione": "Bolzano/Bozen"
    },
    {
      "sigla": "CA",
      "denominazione": "Cagliari"
    },
    {
      "sigla": "CB",
      "denominazione": "Campobasso"
    },
    {
      "sigla": "CE",
      "denominazione": "Caserta"
    },
    {
      "sigla": "CH",
      "denominazione": "Chieti"
    },
    {
      "sigla": "CL",
      "denominazione": "Caltanissetta"
    },
    {
      "sigla": "CN",
      "denominazione": "Cuneo"
    },
    {
      "sigla": "CO",
      "denominazione": "Como"
    },
    {
      "sigla": "CR",
      "denominazione": "Cremona"
    },
    {
      "sigla": "CS",
      "denominazione": "Cosenza"
    },
    {
      "sigla": "CT",
      "denominazione": "Catania"
    },
    {
      "sigla": "CZ",
      "denominazione": "Catanzaro"
    },
    {
      "sigla": "EN",
      "denominazione": "Enna"
    },
    {
      "sigla": "FC",
      "denominazione": "Forlì-Cesena"
    },
    {
      "sigla": "FE",
      "denominazione": "Ferrara"
    },
    {
      "sigla": "FG",
      "denominazione": "Foggia"
    },
    {
      "sigla": "FI",
      "denominazione": "Firenze"
    },
    {
      "sigla": "FM",
      "denominazione": "Fermo"
    },
    {
      "sigla": "FR",
      "denominazione": "Frosinone"
    },
    {
      "sigla": "GE",
      "denominazione": "Genova"
    },
    {
      "sigla": "GO",
      "denominazione": "Gorizia"
    },
    {
      "sigla": "GR",
      "denominazione": "Grosseto"
    },
    {
      "sigla": "IM",
      "denominazione": "Imperia"
    },
    {
      "sigla": "IS",
      "denominazione": "Isernia"
    },
    {
      "sigla": "KR",
      "denominazione": "Crotone"
    },
    {
      "sigla": "LC",
      "denominazione": "Lecco"
    },
    {
      "sigla": "LE",
      "denominazione": "Lecce"
    },
    {
      "sigla": "LI",
      "denominazione": "Livorno"
    },
    {
      "sigla": "LO",
      "denominazione": "Lodi"
    },
    {
      "sigla": "LT",
      "denominazione": "Latina"
    },
    {
      "sigla": "LU",
      "denominazione": "Lucca"
    },
    {
      "sigla": "MB",
      "denominazione": "Monza e della Brianza"
    },
    {
      "sigla": "MC",
      "denominazione": "Macerata"
    },
    {
      "sigla": "ME",
      "denominazione": "Messina"
    },
    {
      "sigla": "MI",
      "denominazione": "Milano"
    },
    {
      "sigla": "MN",
      "denominazione": "Mantova"
    },
    {
      "sigla": "MO",
      "denominazione": "Modena"
    },
    {
      "sigla": "MS",
      "denominazione": "Massa-Carrara"
    },
    {
      "sigla": "MT",
      "denominazione": "Matera"
    },
    {
      "sigla": "NA",
      "denominazione": "Napoli"
    },
    {
      "sigla": "NO",
      "denominazione": "Novara"
    },
    {
      "sigla": "NU",
      "denominazione": "Nuoro"
    },
    {
      "sigla": "OR",
      "denominazione": "Oristano"
    },
    {
      "sigla": "PA",
      "denominazione": "Palermo"
    },
    {
      "sigla": "PC",
      "denominazione": "Piacenza"
    },
    {
      "sigla": "PD",
      "denominazione": "Padova"
    },
    {
      "sigla": "PE",
      "denominazione": "Pescara"
    },
    {
      "sigla": "PG",
      "denominazione": "Perugia"
    },
    {
      "sigla": "PI",
      "denominazione": "Pisa"
    },
    {
      "sigla": "PN",
      "denominazione": "Pordenone"
    },
    {
      "sigla": "PO",
      "denominazione": "Prato"
    },
    {
      "sigla": "PR",
      "denominazione": "Parma"
    },
    {
      "sigla": "PT",
      "denominazione": "Pistoia"
    },
    {
      "sigla": "PU",
      "denominazione": "Pesaro e Urbino"
    },
    {
      "sigla": "PV",
      "denominazione": "Pavia"
    },
    {
      "sigla": "PZ",
      "denominazione": "Potenza"
    },
    {
      "sigla": "RA",
      "denominazione": "Ravenna"
    },
    {
      "sigla": "RC",
      "denominazione": "Reggio Calabria"
    },
    {
      "sigla": "RE",
      "denominazione": "Reggio nell'Emilia"
    },
    {
      "sigla": "RG",
      "denominazione": "Ragusa"
    },
    {
      "sigla": "RI",
      "denominazione": "Rieti"
    },
    {
      "sigla": "RM",
      "denominazione": "Roma"
    },
    {
      "sigla": "RN",
      "denominazione": "Rimini"
    },
    {
      "sigla": "RO",
      "denominazione": "Rovigo"
    },
    {
      "sigla": "SA",
      "denominazione": "Salerno"
    },
    {
      "sigla": "SI",
      "denominazione": "Siena"
    },
    {
      "sigla": "SO",
      "denominazione": "Sondrio"
    },
    {
      "sigla": "SP",
      "denominazione": "La Spezia"
    },
    {
      "sigla": "SR",
      "denominazione": "Siracusa"
    },
    {
      "sigla": "SS",
      "denominazione": "Sassari"
    },
    {
      "sigla": "SU",
      "denominazione": "Sud Sardegna"
    },
    {
      "sigla": "SV",
      "denominazione": "Savona"
    },
    {
      "sigla": "TA",
      "denominazione": "Taranto"
    },
    {
      "sigla": "TE",
      "denominazione": "Teramo"
    },
    {
      "sigla": "TN",
      "denominazione": "Trento"
    },
    {
      "sigla": "TO",
      "denominazione": "Torino"
    },
    {
      "sigla": "TP",
      "denominazione": "Trapani"
    },
    {
      "sigla": "TR",
      "denominazione": "Terni"
    },
    {
      "sigla": "TS",
      "denominazione": "Trieste"
    },
    {
      "sigla": "TV",
      "denominazione": "Treviso"
    },
    {
      "sigla": "UD",
      "denominazione": "Udine"
    },
    {
      "sigla": "VA",
      "denominazione": "Varese"
    },
    {
      "sigla": "VB",
      "denominazione": "Verbano-Cusio-Ossola"
    },
    {
      "sigla": "VC",
      "denominazione": "Vercelli"
    },
    {
      "sigla": "VE",
      "denominazione": "Venezia"
    },
    {
      "sigla": "VI",
      "denominazione": "Vicenza"
    },
    {
      "sigla": "VR",
      "denominazione": "Verona"
    },
    {
      "sigla": "VT",
      "denominazione": "Viterbo"
    },
    {
      "sigla": "VV",
      "denominazione": "Vibo Valentia"
    }
  ]